var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01631 16C5.71708 16 5.43387 15.8719 5.24685 15.6466L0.213263 9.58189C-0.123378 9.17724 -0.0539128 8.58307 0.368224 8.26037C0.790361 7.93767 1.41021 8.00426 1.74685 8.40891L5.98959 13.5209L16.2331 0.377318C16.5591 -0.0375799 17.1736 -0.124657 17.6064 0.187796C18.0392 0.50025 18.13 1.0893 17.8041 1.5042L6.80715 15.621C6.62547 15.8566 6.34227 15.9949 6.03769 16H6.01631Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.d44af9a78afb27de00a95cae76abfb56.svg";
export { ForwardRef as ReactComponent };